import { Action } from 'redux';
import { IContentInfo } from '../../../ts/models/IContentInfo';
import { SetDescription } from '../AppActionTypes';

export interface SetDescriptionAction extends Action {
  item: IContentInfo<'database'> | IContentInfo<'table'> | IContentInfo<'metric'> | IContentInfo<'publishedConnection'>;
}

export function setDescriptionAction(item: IContentInfo<'database'> | IContentInfo<'table'> | IContentInfo<'metric'> | IContentInfo<'publishedConnection'>): SetDescriptionAction {
  return {
    type: SetDescription,
    item
  };
}
